import {DAYS_OF_WEEK_LIST, MONTH_SORTED_LIST_GENITIVE} from 'core/constants';
import {IDetailedEvent, IDetailedEventWinery, IEvent} from 'modules/events/types';
import {format} from 'date-fns';
import {ru} from 'date-fns/locale';

export interface IGetEventsGroupedByDay {
    date: string;
    events: IEvent[];
}

export const getEventsGroupedByDay = (eventsList: IEvent[]): IGetEventsGroupedByDay[] => {
    const dataMap = eventsList.reduce((acc: Record<string, IEvent[]>, event: IEvent) => {
        const {eventDate} = event;

        if (!acc[eventDate]) {
            acc[eventDate] = [];
        }

        acc[eventDate].push(event);

        return acc;
    }, {});

    return Object.entries(dataMap).map(([date, events]) => {
        return {
            date,
            events,
        };
    });
};

export const getEventDate = (dateString: string) => {
    const date = new Date(dateString);

    const month = date.getMonth();
    const day = date.getDate();

    return `${day} ${MONTH_SORTED_LIST_GENITIVE[month]}`;
};

export const getEventTime = (begin: string, end?: string | null) => {
    if (!end) {
        return begin;
    }

    return `${begin} - ${end}`;
};

export const getEventDateAndTime = (dateString: string, begin: string, end?: string | null) => {
    const date = format(new Date(dateString), 'dd MMMM, EEEE', {
        locale: ru,
    }).toString();
    const time = getEventTime(begin, end);

    return `${date} | ${time}`;
};

export const getEventDayOfWeek = (dateString: string) => {
    const date = new Date(dateString);
    const dayOfWeek = date.getDay();

    return DAYS_OF_WEEK_LIST[dayOfWeek];
};

// Алгоритм генерации ссылки на оплату YClients
// Если у мероприятия event.YC_ID_ACTIVITY > 0, то:
// Ссылка: https://{store.ycFormId}.yclients.com/company/{store.ycCompanyId}/activity/info/{event.YC_ID_ACTIVITY}?o=act{event.DATE}
// Иначе:
// Ссылка: https://{store.ycFormId}.yclients.com/company/{store.ycCompanyId}/activity/select?o=act{event.DATE}
export const getEventBuyLink = (
    ycFormId: IDetailedEventWinery['ycFormId'],
    ycCompanyId: IDetailedEventWinery['ycCompanyId'],
    ycActivityId: IDetailedEvent['ycActivityId'],
    eventDate: IDetailedEvent['eventDate'],
) => {
    return 0 < Number(ycActivityId)
        ? `https://${ycFormId}.yclients.com/company/${ycCompanyId}/activity/info/${ycActivityId}?o=act${eventDate}`
        : `https://${ycFormId}.yclients.com/company/${ycCompanyId}/activity/select?o=act${eventDate}`;
};

export const getEventsApiQuery = (filtersQuery: string, page: number, pageSize?: number, source?: string) => {
    const searchParamsInstance = new URLSearchParams(filtersQuery);

    if (1 !== page) {
        searchParamsInstance.append('pageNumber', String(page));
    }

    if (pageSize !== undefined) {
        searchParamsInstance.append('pageSize', String(pageSize));
    }

    if (source !== undefined) {
        searchParamsInstance.append('source', source);
    }

    const query = searchParamsInstance.toString();

    if (!query) {
        return '';
    }

    return decodeURIComponent(`?${query}`);
};

export const formatTastingTitle = (
    eventTitle: string,
    eventDate: string,
    address: string,
    metroStations: {
        name: string;
    }[],
): string => {
    const date = new Date(eventDate).toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

    const metroInfo = 0 < metroStations?.length ? ` (метро ${metroStations[0].name})` : '';

    return `Дегустация «${eventTitle}» | Дата: ${date} | Место проведения: ${address}${metroInfo}`;
};

export const formatTastingDescription = (eventTitle: string, previewDescription: string): string => {
    return `Билеты на дегустацию «${eventTitle}» в SimpleWine. О мероприятии: ${previewDescription}`;
};
